module.exports = __webpack_public_path__ + "static/media/MyWFDropdown.a73edea5.svg";